<div class="mat-elevation-z5">
  <mat-toolbar color="primary">
    <mat-icon svgIcon="magnify"></mat-icon>
    <h1 class="mat-title">Zoek een auto</h1>
    <div class="uf-filler"></div>
    <button mat-icon-button matTooltip="sluiten" (click)="close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </mat-toolbar>
  <div class="mat-body">
    <div class="stock-filter hide-hint">
      <div class="form" [formGroup]="filterForm">
        <mat-form-field>
          <mat-label>Merk</mat-label>
          <input formControlName="vehicle.brand" matInput>
        </mat-form-field>
      </div>
    </div>

    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="vehicle.vrn">
        <mat-header-cell *matHeaderCellDef mat-sort-header>kenteken</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.vehicle.vrn}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="vehicle.brand">
        <mat-header-cell *matHeaderCellDef mat-sort-header>merk</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.vehicle.brand}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="vehicle.model">
        <mat-header-cell *matHeaderCellDef mat-sort-header>model</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.vehicle.model}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="vehicle.type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>type</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.vehicle.type}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="vehicle.color">
        <mat-header-cell *matHeaderCellDef mat-sort-header>kleur</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.vehicle.color}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="vehicle.firstAdmissionDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="firstAdmissionDate">jaar</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.vehicle.firstAdmissionDate | date: 'yyyy'}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <button mat-button mat-flat-button (click)="select(item.vehicle)">selecteer</button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let item; columns: displayedColumns" (dblclick)="select(item.vehicle)"></mat-row>
    </mat-table>

    <mat-paginator [length]="dataSource.records" [pageSizeOptions]=pageSizeOptions></mat-paginator>
  </div>
</div>
